import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const PartnerIcon = ({ className }: NewIconProps) => (
  <svg
    className={twMerge('size-[14px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_20177_95567" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
      <rect width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_20177_95567)">
      <path
        d="M5.01634 13.125L3.90801 11.2583L1.80801 10.7917L2.01217 8.63333L0.583008 7L2.01217 5.36667L1.80801 3.20833L3.90801 2.74167L5.01634 0.875L6.99967 1.72083L8.98301 0.875L10.0913 2.74167L12.1913 3.20833L11.9872 5.36667L13.4163 7L11.9872 8.63333L12.1913 10.7917L10.0913 11.2583L8.98301 13.125L6.99967 12.2792L5.01634 13.125ZM6.38717 9.07083L9.68301 5.775L8.86634 4.92917L6.38717 7.40833L5.13301 6.18333L4.31634 7L6.38717 9.07083Z"
        fill="#D4A72C"
      />
    </g>
  </svg>
);
